import ButtonController from "../../../components/containers/buttonController";
import { chartReportConfigs } from "../../../utils/config/chartReportConfig";
import WidgetType from "../../../components/dynamicRenderer/WidgetRenderer";
import { getDownloadData } from "../../../utils/helpers/getDownloadData";
import { useWidgetInfo } from "../../../hooks/widget/useWidgetInfo";
import { useReportData } from "../../../hooks/data/useReportData";
import { useChart } from "../../../hooks/reports/useReportChart";
import CircularProgress from "@mui/material/CircularProgress";
import Sidebar from "../../../components/sidebar/Sidebar";
import NavBar from "../../../components/navbar/NavBar";
import { useLocation } from "react-router-dom";
import "./widgetreport.css";

const WidgetReport = () => {
  const location = useLocation();
  const { reportName, reportId } = location.state || {};

  const { data } = useReportData(reportName, 1000);
  const config = chartReportConfigs[reportName];
  const chart = useChart(config, data);
  const widgetInfo = useWidgetInfo(reportId, reportName);

  return (
    <div className="widgetReportPage">
      <div className="LandingPageContainer">
        <NavBar />
        <Sidebar />
        <div className="widgetReportsPageContent">
          <div className="widgetReportsTop">
            <div className="toggleReportTitle">
              <h1>{reportName}</h1>
            </div>
          </div>
          <div className="widgetReportsMid">
            <div className="widgetReportsWidgetContainer">
              {widgetInfo.map((info, index) => (
                <WidgetType key={index} widgetInfo={info} />
              ))}
            </div>
            <div className="widgetReportsSpace">
              <div className="report">
                <div className="widgetChart">
                  {chart ? ( chart ) : (
                    <div className="loaderWrapper">
                      <CircularProgress />
                    </div>
                  )}
                </div>
                <ButtonController
                  reportName={reportName}
                  onDownloadClick={() => getDownloadData(reportName)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WidgetReport;